import React from 'react'

const AutomationOptionsPlayAndControlMedia = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none" className={className}>
    <path d="M28.0801 32.53V26.11L33.6501 29.32L39.2201 32.53L33.6501 35.75L28.0801 38.96V32.53Z" stroke="black" strokeLinejoin="round" />
    <path
      d="M43.7396 17.5H21.0296C18.9972 17.5 17.3496 19.1476 17.3496 21.18V43.89C17.3496 45.9224 18.9972 47.57 21.0296 47.57H43.7396C45.772 47.57 47.4196 45.9224 47.4196 43.89V21.18C47.4196 19.1476 45.772 17.5 43.7396 17.5Z"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M12.5193 12.98L10.6693 14.06L8.0293 15.58V12.53V9.47998L10.6693 11.01L12.5193 12.08" stroke="black" strokeLinejoin="round" />
    <path d="M12.5293 12.53V9.47998L15.1693 11.01L17.8093 12.53L15.1693 14.05L12.5293 15.58V12.53Z" stroke="black" strokeLinejoin="round" />
    <path
      d="M17.35 24.56H4.09001C3.6182 24.5613 3.15078 24.4694 2.71462 24.2894C2.27847 24.1095 1.88218 23.8451 1.54856 23.5115C1.21493 23.1779 0.950545 22.7816 0.770598 22.3454C0.590651 21.9093 0.498694 21.4418 0.500014 20.97V4.10002C0.498694 3.62821 0.590651 3.16078 0.770598 2.72463C0.950545 2.28848 1.21493 1.89219 1.54856 1.55857C1.88218 1.22494 2.27847 0.960555 2.71462 0.780608C3.15078 0.600661 3.6182 0.508704 4.09001 0.510024H20.96C21.4318 0.508704 21.8993 0.600661 22.3354 0.780608C22.7716 0.960555 23.1678 1.22494 23.5015 1.55857C23.8351 1.89219 24.0995 2.28848 24.2794 2.72463C24.4594 3.16078 24.5513 3.62821 24.55 4.10002V17.5"
      stroke="black"
      strokeLinejoin="round"
    />
    <path
      d="M44.9298 0.5H29.8398C28.4591 0.5 27.3398 1.61929 27.3398 3V12.41C27.3398 13.7907 28.4591 14.91 29.8398 14.91H44.9298C46.3106 14.91 47.4298 13.7907 47.4298 12.41V3C47.4298 1.61929 46.3106 0.5 44.9298 0.5Z"
      stroke="black"
      strokeLinejoin="round"
    />
    <path
      d="M0.5 29.8399L0.5 45.0699C0.5 46.4507 1.61929 47.5699 3 47.5699H11.84C13.2207 47.5699 14.34 46.4507 14.34 45.0699L14.34 29.8399C14.34 28.4592 13.2207 27.3399 11.84 27.3399H3C1.61929 27.3399 0.5 28.4592 0.5 29.8399Z"
      stroke="black"
      strokeLinejoin="round"
    />
    <path
      d="M34.5691 9.83996H32.8191C32.3988 9.83677 31.9888 9.70989 31.6401 9.47516C31.2915 9.24042 31.0197 8.90822 30.8586 8.52001C30.6976 8.13179 30.6544 7.70475 30.7345 7.29216C30.8146 6.87958 31.0145 6.49971 31.3091 6.19996C31.7119 5.80374 32.254 5.58116 32.8191 5.57996H37.8991"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M36.3105 6.92997L37.6705 5.57997L36.3105 4.21997H37.4605L38.8205 5.57997L37.4605 6.92997H36.3105Z" fill="black" />
    <path
      d="M40.1994 5.57996H41.9594C42.3797 5.58315 42.7897 5.71002 43.1383 5.94476C43.487 6.17949 43.7588 6.51169 43.9198 6.8999C44.0808 7.28812 44.124 7.71516 44.0439 8.12775C43.9638 8.54034 43.764 8.9202 43.4694 9.21996C43.0665 9.61618 42.5244 9.83875 41.9594 9.83996H36.8594"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M38.4592 8.47998L37.0992 9.82998L38.4592 11.19H37.3092L35.9492 9.82998L37.3092 8.47998H38.4592Z" fill="black" />
    <path
      d="M6.12575 42.6316C7.26245 42.6089 8.16879 41.834 8.15013 40.9008C8.13146 39.9676 7.19486 39.2296 6.05817 39.2523C4.92147 39.275 4.01513 40.0499 4.03379 40.9831C4.05246 41.9163 4.98906 42.6544 6.12575 42.6316Z"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M8.16055 40.9501L8.06055 35.05" stroke="black" strokeLinejoin="round" />
    <path d="M10.9894 32.372L8.00977 32.4209L8.05291 35.0505L11.0325 35.0017L10.9894 32.372Z" stroke="black" strokeLinejoin="round" />
  </svg>
)

export default AutomationOptionsPlayAndControlMedia
